import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import App from './App';
import { ENV } from './config/environment';
import './index.css';
import { rollbarConfig } from './services/rollbar';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <RollbarProvider config={rollbarConfig}>
      <ErrorBoundary>
        <BrowserRouter>
          <RecoilRoot>
            <App />
          </RecoilRoot>
        </BrowserRouter>
      </ErrorBoundary>
    </RollbarProvider>
  </React.StrictMode>
);

ENV === 'prod' && console.log('Notification sound provided by notificationsounds.com');
